import axios from "axios";
import PointHttpClientService from "@/CommonVueCore/src/services/httpService/axios/pointHttpClientService.js";

export class CProXServiceClient extends PointHttpClientService {
  constructor({ baseUri, requestInterceptorFn, cancelToken}) {
    super({
      baseUrl: baseUri,
      requestInterceptorFn: requestInterceptorFn,
      cancelToken: cancelToken
    });
  }

  async deleteWithBody({ route, data = null, params = null, headers = null, successCallback = null, errorCallback = null } = {}) {
    const request = axios.create({
      baseURL: this.baseUrl,
      params: params || {},
      headers: headers || {},
      timeout: window.appsettings.AppGlobal.ApiTimeOut,
      signal: this.cancelToken?.signal,
    });

    if (this.requestInterceptorFn != null) {
      request.interceptors.request.use(async (config) => {
        await this.requestInterceptorFn();
        return config;
      }, (error) => {
        console.log(error);
        return Promise.reject(error);
      });
    }

    let response;
    try {
      response = await request.delete(route, { data });
      if (successCallback) successCallback(response);
    } catch (error) {
      if (errorCallback) errorCallback(error);
      response = error.response ?? error;
      response.ResponseMessage = error?.response?.data?.ResponseStatus?.Message
        || error?.response?.data?.Message
        || error?.response?.data?.ErrorMessages?.[0];
      response.ResponseErrorCode = error?.response?.data?.ResponseStatus?.ErrorCode
        || error?.response?.data?.Message;
    }

    return response;
  }
}

export const createApiClient = (namespace, requestInterceptorFn = null) => {
  const baseUri = `${window.appsettings.ProjectConfig.ConnectedProject.CProXApiServiceClientUrl}/${namespace}`;
  // const baseUri = `${namespace}`;
  const controller = new AbortController(); // request için controller oluştur
  // const signal = controller.signal;
  return new CProXServiceClient({ baseUri, requestInterceptorFn, cancelToken: controller });
};
